module.exports = __webpack_public_path__ + "static/media/Node.js_logo.2974f020.svg";